// Theme + tenant switcher — persisted via localStorage so choice survives reload.
export type Theme = 'light' | 'dark';

const THEME_KEY = 'clt-theme';
const TENANT_KEY = 'clt-tenant';

export function getTheme(): Theme {
  const stored = localStorage.getItem(THEME_KEY) as Theme | null;
  if (stored === 'light' || stored === 'dark') return stored;
  return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
}
export function setTheme(t: Theme) {
  document.documentElement.dataset.theme = t;
  try { localStorage.setItem(THEME_KEY, t); } catch {}
  const meta = document.querySelector('meta[name="theme-color"]:not([media])') as HTMLMetaElement | null;
  if (meta) meta.content = t === 'dark' ? '#0B1220' : '#D26B2B';
}

export function getTenant(): string {
  return localStorage.getItem(TENANT_KEY) || 'techtatwa';
}
export function setTenant(t: string) {
  document.body.dataset.tenant = t;
  try { localStorage.setItem(TENANT_KEY, t); } catch {}
}
